import React from "react";
import img from "../../../assets/images/image1.png";
import { openLinkInNewTab } from "../../../helpers/helperMethods";
import Introduction from "../introductions/ImageIntroduction";

export default () => {
  const content = {
    insideContent: (
      <>
        <p className="imgIntroductionTitle">Grow your business with NONEHO</p>
        <button className="button" onClick={() => openLinkInNewTab()}>
          Create Ad
        </button>
      </>
    ),
    backgroundImage: img,
  };

  return <Introduction content={content} />;
};
